import { Button, Form, Input, Modal, notification, Select, Table } from "antd"
import { useEffect, useState } from "react"
import { EmailConfigView } from "../../interfaces/EmailConfig"
import { ASSISTANCE_APPLICATION, DONATION_APPLICATION, FEEDBACK, JOIN_APPLICATION, UPGRADE_APPLICATION } from "../../constant/emailRecipientKeys"
import { getEmailConfig, modifyEmailConfig } from "../../api"

const EmailConfig = () => {
    const [isOpenModal, setisOpenModal] = useState(false)
    const [data, setData] = useState<EmailConfigView[]>()
    const [api, contextHolder] = notification.useNotification();
    const [form] = Form.useForm()

    const emailKeyAlias = new Map<string, string>()
    emailKeyAlias.set(JOIN_APPLICATION, "加入申请")
    emailKeyAlias.set(DONATION_APPLICATION, "捐助申请")
    emailKeyAlias.set(ASSISTANCE_APPLICATION, "受助申请")
    emailKeyAlias.set(UPGRADE_APPLICATION, "升档申请")
    emailKeyAlias.set(FEEDBACK, "反馈申请")

    const emailDomainOptions = [
        { value: "TENCENT", label: "腾讯" },
        { value: "NETEASE", label: "网易" }
    ]
    const columns = [
        {
            title: "邮箱类型",
            dataIndex: "key",
            render: (val: string) => emailKeyAlias.get(val)
        },
        {
            title: "邮箱地址",
            dataIndex: "email"
        },
        {
            title: "邮箱公司",
            dataIndex: "company",
            render: (val: string) => {
                return val === "TENCENT" ? "腾讯" : "网易"
            }
        },
        {
            title: "授权码",
            dataIndex: "authCode"
        },
        {
            title: "操作",
            render: (res: any) => {
                return (
                    <div>
                        <Button type="primary" onClick={() => handleClick(res)}>编辑</Button>
                    </div>
                )
            }
        }
    ]

    const getConfigs = async () => {
        const { data } = await getEmailConfig()
        setData(data)
    }

    const handleClick = (columnData: EmailConfigView) => {
        const deepCloneData = JSON.parse(JSON.stringify(columnData))
        form.setFieldsValue(deepCloneData)
        setisOpenModal(!isOpenModal)
    }

    const handleOk = async () => {
        let emailConfig
        try {
            emailConfig = await form.validateFields()
        } catch (error) {
            api.error({
                message: `请填写完整信息！`,
                placement: 'top',
            })
            return
        }
        const { status } = await modifyEmailConfig(emailConfig)
        if (status == 200) {
            api.success({
                message: `修改邮箱模版成功！`,
                placement: 'top',
            });
        } else {
            api.error({
                message: `修改邮箱模版失败！`,
                placement: 'top',
            });
        }
        getConfigs()
        setisOpenModal(!isOpenModal)
    }
    useEffect(() => { getConfigs() }, [])
    return <div>
        {contextHolder}
        <Table rowKey={'key'} columns={columns} dataSource={data} pagination={{ hideOnSinglePage: true }} />
        <Modal
            title="编辑"
            open={isOpenModal}
            onOk={handleOk}
            onCancel={() => setisOpenModal(!isOpenModal)}
        >
            <Form
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                labelAlign="left"

            >
                <Form.Item<EmailConfigView>
                    label="邮箱主键："
                    name="key"
                >
                    <Input disabled />
                </Form.Item>
                <Form.Item<EmailConfigView>
                    label="邮箱地址："
                    name="email"
                    rules={[{ required: true, message: "请输入邮箱地址" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item<EmailConfigView>
                    label="隶属公司："
                    name="company"
                    rules={[{ required: true, message: "请选择邮箱隶属的公司" }]}
                >
                    <Select
                        defaultValue="TENCENT"
                        options={emailDomainOptions}
                    />
                </Form.Item>
                <Form.Item<EmailConfigView>
                    label="邮箱授权码："
                    name="authCode"
                    rules={[{ required: true, message: "请输入邮箱授权码" }]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    </div>
}

export default EmailConfig
